module.exports = __webpack_public_path__ + "static/img/putcontent_4.45270b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/putcontent_4.png
// module id = qL2b
// module chunks = 1